import React, { Component } from 'react';
export default class TabPanel_Tab extends Component {
	constructor(props){
		super(props);
		const {panel, tabInfo, setActive, active}=props;
		this._setActive = setActive
		this._panel = panel;
		this._tabInfo = tabInfo;
		this._handleSetActive = this._handleSetActive.bind(this);
		this.state = {active:active?true:false};
	}
	_handleSetActive(){
		this._setActive(this, this._panel.ref.current);
	}
	set active(value){
		this.setState({active:value});
	}
	render() {
		let className = "tab-panel-tab";
		if(this.state.active)
			className+=" active";
		const tabInfoClassName = this._tabInfo?.className;
		if(tabInfoClassName)
			className+=' '+tabInfoClassName;
		return (<div className={className} onClick={this._handleSetActive}>
		<div className="inner">
			{this._tabInfo.title}
			</div>
				</div>)
	}
}
